/**
 * A calendar date from the API, shown as a calendar date.
 *
 * premiumExpiry is a date with no time ("2030-01-04", or [2030, 1, 4] from
 * older serialisation). `new Date("2030-01-04")` parses that as UTC midnight,
 * and every US timezone then displays the evening before: a grant through
 * January 4 read as January 3 on the profile and subscription pages. Building
 * the Date from its parts keeps it in local time, so the day stays the day.
 */
export const parseDateOnly = (value) => {
    if (!value) {
        return null;
    }
    let date = null;
    if (Array.isArray(value) && value.length === 3) {
        const [year, month, day] = value;
        date = new Date(year, month - 1, day);
    } else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        date = new Date(year, month - 1, day);
    } else {
        date = new Date(value);
    }
    return Number.isNaN(date.getTime()) ? null : date;
};

/** "January 4, 2030", or null when there is nothing to show. */
export const formatDateOnly = (value) => {
    const date = parseDateOnly(value);
    if (!date) {
        return null;
    }
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};
